import "./index.css";
import React, { useEffect, useState, Fragment, useRef } from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import PortfolioModal from "./components/PortfolioModal";
import PortfolioCard from "./components/PortfolioCard";
import ConfirmationModal from "../../components/ConfirmationModal";
import { IMAGE_UPLOAD, YOUTUBE_URL } from "../../Constants/types";
import { getFilePath } from "../../Utils/utils";
import AddButton from "../../components/AddButton";

export default function ProductPortfolio({ location, history }) {
  const buttonRef = useRef();

  const [isLoading, setLoading] = useState(true);
  const [adminProfile, setAdminProfile] = useState(null);
  const [brandData, setBrandData] = useState(null);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
      return;
    }

    const adminData = {
      brandId: location.state.brand,
      role: location.state.role,
      username: location.state.username,
      type: location.state.type,
      uid: localStorage.getItem("uid"),
    };
    setAdminProfile(adminData);

    Firebase.getBrandDataByID(adminData.brandId, (res) => {
      res && setBrandData(res);
      setLoading(false);
    });
  }, []);

  const onEditPortfolio = (portfolio) => {
    setSelectedPortfolio(portfolio);
    buttonRef.current.click();
  };

  const removeFilesFromStorage = async (files) => {
    if (!files || files.length === 0) return;

    const deletePromises = files
      .filter((item) => item && item.mediaType !== YOUTUBE_URL)
      .map(async (item) => {
        const path = getFilePath("portfolios", item.mediaUrl, item.mediaType);
        try {
          await Firebase.deleteFile(path);
        } catch (e) {
          console.error("Error deleting file:", e);
        }
      });

    await Promise.all(deletePromises);
  };

  const onDeletePortfolio = async () => {
    try {
      // 1. delete all media from storage
      const { media, portfolioLogo, id: portfolioId } = selectedPortfolio;
      const logoObj = { mediaUrl: portfolioLogo, mediaType: IMAGE_UPLOAD };

      const mediaArray = media.flatMap((cur) => cur.uploads);

      const mediaToDelete = portfolioLogo
        ? [...mediaArray, logoObj]
        : [...mediaArray];
      await removeFilesFromStorage(mediaToDelete);

      // 2. delete entry from db
      await Firebase.deleteBrandPortfolioById(
        adminProfile.brandId,
        portfolioId
      );
    } catch (e) {
      console.error("Error deleting portfolio", e);
      selectedPortfolio(null); // reset selection even on error
    }
  };

  return isLoading ? (
    <main className="registration__fade-loader">
      <div className="registration__loading-brand-icon" />
      <i className="fa fa-3x fa-sync fa-spin text-muted" />
    </main>
  ) : (
    <Fragment>
      <Header
        username={adminProfile.username}
        role={adminProfile.role}
        brand={adminProfile.brandId}
        logo={brandData.logo}
        brandName={brandData.name}
      />
      <main className="portfolio">
        <div className="portfolio__top-container">
          <AddButton
            label="+ Add a new portfolio"
            dataTarget="#portfolio-modal"
            hex={brandData.hex}
            white={brandData.white}
          />
        </div>
        <section
          className={`portfolio__content ${
            brandData.portfolios ? "" : "portfolio__content--empty"
          }`}
        >
          {brandData.portfolios ? (
            <ul className="portfolio__list">
              {Object.values(brandData.portfolios).map((item, i) => (
                <li className="portfolio__list-item" key={i}>
                  <PortfolioCard
                    portfolio={item}
                    brandIcon={brandData.icon}
                    onEditPortfolio={onEditPortfolio}
                    brandId={adminProfile.brandId}
                  />
                </li>
              ))}
            </ul>
          ) : (
            <p>You did not add any portfolios yet</p>
          )}
          <PortfolioModal
            brandData={brandData}
            brandId={adminProfile.brandId}
            selectedPortfolio={selectedPortfolio}
            setSelectedPortfolio={setSelectedPortfolio}
          />
          <button
            ref={buttonRef}
            style={{ display: "none" }}
            data-toggle="modal"
            data-target="#portfolio-modal"
          />
          <ConfirmationModal
            id="delete-portfolio"
            onClick={onDeletePortfolio}
            title="Are you sure you want to delete this portfolio entry?"
            classNames="super-products__confirm-btn"
            hex={brandData.hex || "white"}
            white={brandData.white ? "white" : "black"}
          />
        </section>
      </main>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/index.js